import moment from "moment-timezone";
import { Activity } from "@/lib/api/customer";
import { CommonDestinationTimezone } from "@/lib/api/document";

/** Customer name and call time, shown under a todo modal's title. Call time exists only for automation todos. */
export function TodoContextLine({ todo }: { todo: Activity | null }) {
  const customerName = todo?.Customer?.long_name;
  const callStartedAt = todo?.Call?.call_started_at;
  if (!customerName && !callStartedAt) return null;

  return (
    <p className="text-sm text-muted-foreground" data-testid="todo-context">
      {customerName && <span className="font-medium text-foreground">{customerName}</span>}
      {customerName && callStartedAt && " · "}
      {callStartedAt && (
        <span>
          Call{" "}
          <time dateTime={callStartedAt}>
            {moment.tz(callStartedAt, CommonDestinationTimezone).format("MMM Do YYYY, h:mm A z")}
          </time>
        </span>
      )}
    </p>
  );
}
